import { useEffect } from "react";

import ActivitiesIcon from "@/icons/ActivitiesIcon";
import videoPlayerEvents from "@/view/constants/videoPlayerEvents";
import usePresentModeContext from "@/view/utils/usePresentModeContext";
import useVideoEventBus from "@/view/utils/useVideoEventBus";
import VideoQuizQuestions from "@/view/VideoQuizQuestions";
import {
  rootCss,
  headerCss,
  headingCss,
  iconCss,
} from "./VideoMobilePresentModeQuiz.style";

const { VIEW_PAGE_EVENT } = videoPlayerEvents;

// This component is only rendered when video present mode is active on a mobile screen.
const VideoMobilePresentModeQuiz = () => {
  const { sendVideoPlayerEvent } = useVideoEventBus();
  const { activitiesPanelIsAtBottomOfPage } = usePresentModeContext();

  useEffect(() => {
    sendVideoPlayerEvent(VIEW_PAGE_EVENT.RESET_ACTIVITY_PANEL_CONTENTS);
  }, [activitiesPanelIsAtBottomOfPage]);

  return (
    <div css={rootCss}>
      <div css={headerCss}>
        <ActivitiesIcon css={iconCss} />
        <h2 css={headingCss}>Activities</h2>
      </div>
      <VideoQuizQuestions />
    </div>
  );
};

export default VideoMobilePresentModeQuiz;
